import { MuiMaterials } from '../@index.js';
import React from 'react'
import Center from './Center'
import useForm from '../hooks/useForm.js'
import { useLocation, useNavigate } from "react-router-dom";
import { createApiEndpoint } from '../index.js'
import * as global from '../data/global';
import { useAuth } from "../provider/authProvider";
import nodeRSA from "node-rsa";

const Loading = () => {
    const { setToken } = useAuth();
    const { state } = useLocation();
    const navigate = useNavigate();
    const login = async (e) => {
        //const loading = window.document.getElementsByClassName("loading")[0];
        //const content = window.document.getElementsByClassName("content")[0];
        //content.style.display = "none";
        //loading.style.display = "inherit";
        e.preventDefault();

        if (validate()) {
            let userExists = await createApiEndpoint(global.Endpoints.GrainWave)
                .fetchLogin(state.values.wall);

            if (userExists) {
                setToken("this is a test token");
                navigate("/", { replace: true });
            }
            else {
                navigate("/");
            }
        }
    };

    const validate = () => {
        return true;
        //let temp = { wall: null };
        //temp.wall = state.values.wall && state.values.wall !== "" ? "" : "This field is required.";
        //state.setErrors(temp);
        //return Object.values(temp).every(x => x === "");
    };

    if (state && state.action === "login") {
        login(state.e);
    }

    return (
        <MuiMaterials.Box
            sx={{
                fontSize: "50px",
                color: "rgb(244, 204, 142)",
                margin: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div style={{ marginTop: "-92px" }}>
                <MuiMaterials.RotatingLines
                    strokeColor="#f4cc8e"
                    strokeWidth="3"
                    animationDuration="0.72"
                    width="48"
                    visible={true}
                />
            </div>
        </MuiMaterials.Box>
    );
};

export default Loading